<template lang="pug">
.delete-btn(@click="$emit('delete')") 删除
  
</template>
<script>
export default {
  name: 'DeleteBtn',
  props: {},
  data() {
    return {}
  },
  computed: {},
  methods: {},
  mounted() {},
}
</script>

<style scoped lang="sass">
@import "src/styles/common.sass"
.delete-btn
  width: pxToRem(110)
  height: pxToRem(60)
  border-radius: pxToRem(30)
  border: 1px $cl-blue solid
  color: $cl-blue
  font-size: pxToRem(24)
  line-height: pxToRem(52)
  text-align: center
</style>
